export class CartIsInActive extends Error {
  constructor(message) {
    super(message);
    this.name = 'CartIsInActive';
  }
}
